'use es6';

import { getLegalConsentSubscriptionsFilter } from 'FormsCommonComponents/utils/BusinessUnitsUtils';
import { hasBusinessUnitsAccess as getHasBusinessUnitsAccess } from 'FormsUI/selectors/BusinessUnitsAccess';
import { getCurrentFormBusinessUnitId } from 'FormsUI/selectors/Editor';
import { getSubscriptionDefinitions } from 'FormsUI/selectors/LegalConsent';
import { isUngatedForCampaignBusinessUnit as getIsUngatedForCampaignBusinessUnit } from 'FormsUI/selectors/Gates';
const getSubscriptionsForLegalConsent = state => {
  const businessUnitId = getCurrentFormBusinessUnitId(state);
  const subscriptionDefinitions = getSubscriptionDefinitions(state);
  const hasBusinessUnitsAccess = getHasBusinessUnitsAccess(state);
  const isUngatedForCampaignBusinessUnit = getIsUngatedForCampaignBusinessUnit(state);
  const businessUnitsFilter = getLegalConsentSubscriptionsFilter({
    businessUnitId,
    hasBusinessUnitsAccess,
    isUngatedForCampaignBusinessUnit
  });
  const filteredSubscriptionDefinitions = subscriptionDefinitions.filter(i => i.active).filter(businessUnitsFilter);
  return filteredSubscriptionDefinitions;
};
export default getSubscriptionsForLegalConsent;